import "./Auth.scss";
import { authImg, logo, textImg } from "assets/images";
import { Button, Input } from "components/form";
import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import usePasswordToggle from "hooks/usePasswordToggle";
import useButtonLoader from "hooks/useButtonLoader";
import { removeErrorFields, validateInput } from "validation";
import { auth } from "validation/schema/auth";
import { loginUserApi } from "services/auth";
import { setToLocal } from "config/axiosInstance";
import { toastMessage } from "utils/toastMessageHelper";
import commonMessages from "constant/commonMessage";
import useNavigation from "hooks/useNavigation";
import { useTranslation } from "react-i18next";
// import { requestForToken } from "config/firebase";

const { ALLOW_RESEARCHER } = commonMessages;

const Login = () => {
  // Hook
  const [inputType, icon] = usePasswordToggle();

  const { navigateTo } = useNavigation();
  const [token, setToken] = useState("");

  // Set all value
  const [inputData, setInputData] = useState({});
  const [error, setError] = useState({});
  const { t, i18n } = useTranslation();

  // const buttonText = t("AUTH.loginButton");

  const [loginButtonLoader, setLoginButtonLoader, renderContent] =
    useButtonLoader(t("LOGIN.loginButton"));

  // Change handler
  const changeHandler = (event) => {
    const { name, value } = event.target;
    setInputData({ ...inputData, [name]: value });

    setError((prevError) => removeErrorFields(prevError, name));
  };

  // input validation
  const validation = () => {
    const { errors, status } = validateInput(
      inputData,
      "loginSchema",
      auth,
      null
    );
    setError(errors);
    return status;
  };

  // login Handler function
  const userLoginHandler = async (e) => {
    e.preventDefault();
    if (validation()) {
      try {
        setLoginButtonLoader(true);

        const sendData = {
          ...inputData,
          isWeb: true,
          // fcmToken: await requestForToken(),
          deviceType: "web",
        };

        const {
          data = {},
          message = "",
          status,
        } = await loginUserApi(sendData);

        if (status === 200) {
          setToLocal("token", data.token);
          setToLocal("currentUserRole", data?.user?.currentUserRole);
          // setToLocal("i18nLng", "en", null);
          navigateTo("/dashboard/create-survey");
          toastMessage(message, "success", "userLogin");
        }
      } catch (e) {
        console.log("error", e);
      } finally {
        setLoginButtonLoader(false);
      }
    }
  };

  // useEffect(() => {
  //   document.body.dir = i18n.dir();
  // }, [i18n.language]);

  return (
    <>
      <div className="auth_page">
        <div className="image_section">
          <img src={logo} alt="" className="logo" />
          {/* <img src={authImg} alt="" className="side_img" /> */}
          <img src={textImg} alt="" className="text_img" />
        </div>
        <div className="auth_form">
          <form>
            <div className="form_title">
              <div className="form_title">
                <h3>{t("LOGIN.loginTitle")}</h3>
              </div>
            </div>
            <div className="form_field">
              <Input
                type="text"
                placeholder={t("LOGIN.emailOrPhone")}
                name="username"
                label={t("LOGIN.emailOrPhone")}
                value={inputData?.username}
                onChange={changeHandler}
                error={error?.username}
                extraError={error?.usernameErr}
                maxLength={320}
              />
            </div>
            <div className="form_field password">
              <Input
                type={inputType}
                placeholder={t("LOGIN.loginEnterPassword")}
                name="password"
                label={t("LOGIN.password")}
                value={inputData?.password}
                onChange={changeHandler}
                error={error?.password}
              />
              <span className="password_icons">{icon}</span>
            </div>
            <p className="forgot_password_redirect">
              <Link to="/forgot-password">{t("LOGIN.forgetPassword")}</Link>
            </p>
            <div className="button_wrap">
              <Button
                type={"button"}
                ref={loginButtonLoader}
                onClick={userLoginHandler}
              >
                {renderContent}
              </Button>
            </div>
            <p className="redirect_singUp">
              {t("LOGIN.noAccount")}
              <Link to="/signup" className="blue">
                {t("LOGIN.signUp")}
              </Link>
            </p>
          </form>
        </div>
      </div>
    </>
  );
};

export default Login;
